import mockUtils from './utils'


const mockCaptcha = "data:image/png;base64,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"


export default {


    phoneToSet: null,


    //запрос на смену адреса электронной почты
    phoneReg(phone, captcha, ignore) {


        this.phoneToSet = phone

        return new Promise((resolve, reject) => {

            setTimeout(() => {
                /*          this.waitEmail = newEmail */



                if (captcha) {


                    if (captcha == '68366') {
                        resolve({
                            status: 0
                        })
                    } else {
                        resolve({
                            status: 1,
                            captcha: mockCaptcha
                        })
                    }


                } else {

                    if (ignore) {
                        resolve({
                            status: 0
                        })
                    } else {


                        let status = mockUtils.getRandomInt(0, 4)


                        let result = {
                            status
                        }

                        if (status == 1) {
                            result = Object.assign(result, {
                                captcha: mockCaptcha
                            })


                        }

                        resolve(result);
                    }



                }


            }, 1000);
        });
    },

    phoneConfirm(confirmCode) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (confirmCode == '123456') {


                    this.userInfo.contacts.phone = this.phoneToSet
                    this.phoneToSet = null
                    resolve()
                } else {
                    reject({
                        code: 10,
                        message: 'Неверный код подтверждения'
                    });
                }
            }, 5000);
        });

    },


    changePin(pin) {

        return new Promise((resolve, reject) => {
            setTimeout(() => {

                resolve()
            }, 1000);
        });


    },


    /**
     * Сброс текущей сессии, если она была
     * @returns {Promise}
     */
    resetUser() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {

                resolve()
            }, 1000);
        });
    },

    /**
     * Пропуск этап привязки услуг при регистрации
     * @returns {Promise}
     */
    skipWire() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {

                resolve()
            }, 1000);
        });
    }

}